import { asyncLoad } from '@util'
const AsyncView = asyncLoad(() =>
  import('@components/LocalMerchant/VR/Detail/View')
)

export default {
  path: 'view',
  component: AsyncView
}
